<template>
  <a class="btn btn-outline-dark" role="button" :href="google_map_link" target="_blank">
    <show-icon name="location_on" size="sm" class="align-middle"></show-icon>
    <span class="d-none d-sm-inline">{{ $t("open_map_app") }}</span>
  </a>
</template>

<script>
  export default {
    props: [
      "lat",
      "long"
    ],
    setup(props) {
      const lat = props.lat.toFixed(8); // need at least 6 digits to trigger google map in ios
      const lng = props.long.toFixed(8);
      const google_map_link = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      return {
        google_map_link
      };
    }
  }
</script>